<div class="frameworks-tags">
  <span *ngFor="let language of languages | slice:0:displayNumber;">{{language}}</span>
  <span class="cur-pointer" *ngIf="moreLanguages > 0" (click)="open()" appStopPropagation>{{moreLanguages}}+</span>
</div>
